import { sharedContentPreviewUrl } from './shared-content-url';

/**
 * Resolve a game/template image URL for display in the admin. Game and template
 * images are shared-content URLs now (relative `/content/...`, or absolute for
 * externally-hosted ones), so this just defers to the shared-content resolver.
 *
 * The former `/game-content` prefix (from when images were stored admin-side) is
 * gone — it produced `/game-content/content/...` 404s once overrides started
 * pointing at the shared store.
 */
export function resolveGameContentUrl(url: string | null | undefined): string {
    return sharedContentPreviewUrl(url);
}
